<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Student progress</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'Home'}">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Student progress</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="organizations-organizations">
          <div class="card-header">
            <div class="btn-toolbar pull-right">
              <button class="btn btn-info" type="button" @click="showFilter = !showFilter">
                <i class="fa fa-filter"></i> Filter
              </button>
            </div>
            <div class="btn-toolbar pull-right">

            </div>
          </div>
          <form @submit.prevent="setFilter" method="GET" novalidate>
            <div class="card-body" v-if="showFilter">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="name">Name</label>
                    <div class="col-md-9">
                      <input type="text" id="name" class="form-control" v-model="filter.name" placeholder="Name">
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="username">Pin</label>
                    <div class="col-md-9">
                      <input type="text" id="username" class="form-control" v-model="filter.username" placeholder="Pin">
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-9 offset-md-3">
                      <button type="submit" class="btn btn-common m-2px"><i class="fas fa-search"></i> Search</button>
                      <button type="reset" class="btn btn-warning" @click="resetFilter()"><i class="fas fa-undo"></i>
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="overlay" v-if="is_loading">
            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
          </div>

          <div class="card-body table-responsive-md p-0">
            <table class="table">
              <thead>
              <tr>
                <th>User Name (From Brac bank)</th>
                <th>No of In Progress Courses</th>
                <th>No of Completed Courses</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(val, index) in visitors.data">
                <td>{{ val.user.name }}</td>
                <td>
                  <el-button round @click="$emit('in-progress-courses', val.user.id)">{{ val.below_100_percent }}</el-button>
                </td>
                <td>
                  <el-button round @click="$emit('completed-courses', val.user.id)">{{ val.completed_100_percent }}</el-button>
                </td>
              </tr>
              </tbody>
            </table>
            <div class="col-12 p-4" v-if="_.isEmpty(visitors)">
              <div class="alert alert-default-warning" role="alert">
                No data found!
              </div>
            </div>
          </div>
          <div class="card-footer">
            <vue-pagination
              :pagination="visitors"
              v-if="visitors.total > visitors.per_page"
            />
          </div>
        </div>
      </div>
    </section>

    <in-progress-courses/>
    <completed-courses/>

  </div>
</template>

<script>
import {LearningReportApi} from '@/services/api'
import SortIcons from "@/components/utils/SortIcons.vue"
import VuePagination from "@/components/partials/PaginationComponent.vue"

export default {
  name: 'StudentProgress',
  metaInfo: {
    title: "Student progress | Dotlines"
  },
  components: {
    VuePagination,
    SortIcons,
    InProgressCourses: () => import('./components/InProgressCoursesModal.vue'),
    CompletedCourses: () => import('./components/CompletedCoursesModal.vue')
  },
  data: () => ({
    visitors: {},
    filter: {},
    showFilter: false,
    is_loading: false
  }),
  methods: {
    getVisitors() {
      this.is_loading = true
      this.filter = JSON.parse(JSON.stringify(this.$route.query))
      if (!_.isEmpty(this.filter)) this.showFilter = true
      //let params = { ...this.filter, ...this.$route.query }

      LearningReportApi.studentProgress(this.filter).then(visitors => {
        this.visitors = visitors
      }).catch(error => {
        console.log('error: ', error)
      }).finally(() => {
        this.is_loading = false
      })
    },
    setFilter() {
      this.$router
        .push({
          path: this.$route.fullPath,
          query: this.filter
        })
        .catch((err) => {
          //console.log(err)
        })
    },

    resetFilter() {
      this.$router.push({path: this.$route.path}).catch(() => {
      })
    }
  },
  mounted: function () {
    if (this.isMobile()) {
      window.$(document).find('.push-menu-class').trigger('click')
    }
    this.getVisitors()
  }
}
</script>
